import account_manager from './account_manager.json'
import client from './client.json'
import common from './common.json'
import creator from './creator.json'
import document from './document.json'
import http from './http.json'
import user from './user.json'

export default {
  account_manager,
  client,
  common,
  creator,
  document,
  http,
  user,
}
